import { DBO_V } from '@op/utils/format';

export const ACCOUNT_DATA_SHOW = [
  { key: 'exposure', text: 'Impressions' },
  { key: 'avg_five_week_exposure', text: 'Past 5-week Average', width: 240 },
  { key: 'views', text: 'Views-1', header: 'Views' },
  { key: 'engagements', text: 'Engagement' },
  {
    key: 'engagements_rate',
    text: 'Engagement%',
    format: (value: number) => DBO_V.ratio_min(value),
    numFmt: ['0.00%'],
    isPercentage: true,
  },
  { key: 'followers', text: 'Followers' },
  { key: 'posts', text: 'Publications' },
];

export const CHART_METRIC_LIST = ACCOUNT_DATA_SHOW.filter(
  item => !['avg_five_week_exposure'].includes(item.key),
);
